module.exports = __webpack_public_path__ + "img/wxPay.ac3b7243.png";